<template>
  <div class="publication-item" data-aos="fade-in">
    <SmartLinkItemComponent :id="model?.system?.id" :component="!model?.system?.workflow" v-if="model">       
        <SmartLinkStandaloneElement :codename="type.elements.publication_date.codename">
            <div class="publication-date" v-if="model.elements.publication_date.value">
                {{ formatDate(model.elements.publication_date.value) }}
            </div>
        </SmartLinkStandaloneElement>
        <SmartLinkStandaloneElement :codename="type.elements.publication_title.codename">
            <div class="publication-title" v-if="model.elements.publication_title.value">
                <h3>{{ model.elements.publication_title.value }}</h3>
            </div>
        </SmartLinkStandaloneElement>
        <SmartLinkStandaloneElement :codename="type.elements.author_information.codename">
            <div class="author-information">
                <p>{{ model.elements.author_information.value }}</p>
            </div>
        </SmartLinkStandaloneElement>
        <NuxtLink class="publication-link" :to="model.elements.link_to_publication.value" :external="true" >                
            <span class="text">View {{ getViewText(model) }}</span>
            <IconArrowRightLong class="icon" />
        </NuxtLink>      
    </SmartLinkItemComponent>
  </div>
</template>
<script lang="ts" setup>
import { contentTypes, taxonomies, type PublicationItemModel } from '~~/app/models';
const type = contentTypes._publication_item;

const props = defineProps<{ model: PublicationItemModel }>();


const typeMap: { [key:string]:string | undefined} = {
    'press_release': 'Press Release',
    'conference': 'Conference',
    'highlight': 'Highlight'
}

function getViewText(item:PublicationItemModel ){
    
    const typ = firstOrDefault(item.elements.publication_type.value)?.codename
    if (typ){

        const data = typeMap[typ]
        if (data){
            return data;
        } 
    }

    return 'Publication';
}
</script>